import './App.css'; // Import global styles
import * as React from 'react';
import { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation, useParams } from 'react-router-dom';
import CallbackPage from './CallbackPage';
import LoginPage from './pages/LoginPage';
import SubmissionPage from './pages/SubmissionPage';
import ResultsPage from './pages/ResultsPage';
import TestPage from './pages/TestPage';
import AnswerComparisonPage from './pages/AnswerComparisonPage';
import HomePage from './pages/HomePage';
import { getAccessToken } from './utils/auth';

function DebugLocation() {
  const location = useLocation();
  console.log('debugging horrayyyyyyyy')
  console.log('App.js - Current Path ::::', location.pathname); // Logs the current route
  return null;
}

function ResultsRoute({ isAuthenticated }) {
  const { batch_id } = useParams();

  return isAuthenticated ? (
    <ResultsPage />
  ) : (
    <Navigate to={`/login?redirect=${encodeURIComponent(`/results/${batch_id}`)}`} />
  );
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // Track loading state
  const location = useLocation();
  useEffect(() => {
    const checkAuth = () => {
      let accessToken = getAccessToken();
  
      console.log('Auth check - Retrieved accessToken:', accessToken);
      setIsAuthenticated(!!accessToken);  
      setIsLoading(false);
    };
  
    // ✅ **Wait for auth-updated event before checking auth**
    window.addEventListener('auth-updated', () => {
      console.log('Auth-updated event received. Rechecking authentication.');
      checkAuth();
    });
  
    // ✅ **Delay authentication check slightly**
    setTimeout(() => checkAuth(), 50);
  
    return () => {
      window.removeEventListener('auth-updated', checkAuth);
    };
  }, []);

  // Show a loading screen while determining authentication status
  if (isLoading) {
    return (
      <div className="App">
        <h1>Loading...</h1>
      </div>
    );
  }

  console.log('app js isAuthenticated:', isAuthenticated);

  return (
    <>
      <DebugLocation /> {/* Logs route changes */}
      <Routes>
        {/* Redirect based on authentication */}
        <Route exact
          path="/"
          element={isAuthenticated ? <Navigate to="/homepage" /> : <LoginPage />}
        />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/batch_ask"
          element={isAuthenticated ? <SubmissionPage /> : <Navigate to="/login" />}
        />
        <Route path="/blabla" element={<TestPage />} />
        <Route path="/answer_comparison" element={<AnswerComparisonPage />} />
        <Route path="/homepage" element={<HomePage />} />
        <Route path="/callback" element={<CallbackPage />} />
        <Route
              path="/results/:batch_id"
              element={
                  isAuthenticated ? (
                      <ResultsRoute isAuthenticated={isAuthenticated} />
                            ) : ( <Navigate to={`/login?returnUrl=${encodeURIComponent(location.pathname)}`} />)
                      }
        />
        {/* 404 - Page Not Found */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

function NotFoundPage() {
  return (
    <div className="App">
      <h1>404 - Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>
    </div>
  );
}

export default App;